import { http } from '@api/client';
import { http_v2 } from '@api/client';
import { PaginatedResponse } from '@api/shared';
import { paramterize, pickResponse } from '@api/utils';

export function designationSearch({ searchKey = '' }) {
  return http_v2
    .get<DesignationDetail>('/roles', {
      params: paramterize({
        [searchKey]: '',
      }),
    })
    .pipe(pickResponse());
}

export function rolesSearch({ searchKey = '' }) {
  return http
    .get<roleDetail>('/roles', {
      params: paramterize({
        [searchKey]: '',
      }),
    })
    .pipe(pickResponse());
}

interface DesignationDetail {
  data: string[];
}

interface roleDetail {
  data: string[];
}

interface NewDesignationDetail {
  designation_name: string;
}

export function newDesignation(desingation: Partial<NewDesignationDetail>) {
  return http_v2.post(`/roles`, desingation).pipe(pickResponse());
}
